module.exports = __webpack_public_path__ + "img/contact-logo.470b4f47.png";